module.exports = __webpack_public_path__ + "img/android-download.ade7e785.png";